import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloseIcon from "@mui/icons-material/Close";
import "./InterviewSuccessModal.scss";

interface InterviewSuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  /** Show "Stay here" button (only on profile page) */
  showStayHere?: boolean;
  onViewOtherProfiles: () => void;
}

function InterviewSuccessModal({
  isOpen,
  onClose,
  showStayHere = false,
  onViewOtherProfiles,
}: InterviewSuccessModalProps) {
  if (!isOpen) return null;

  return (
    <div className="interview-modal__overlay" onClick={onClose}>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
      <div className="interview-modal" onClick={(e) => e.stopPropagation()}>
        <button type="button" className="interview-modal__close" onClick={onClose} aria-label="Close">
          <CloseIcon sx={{ fontSize: 20, color: "#555555" }} />
        </button>
        <div className="interview-modal__content">
          <div className="interview-modal__icon-row">
            <CheckCircleIcon sx={{ fontSize: 48, color: "#168254" }} />
          </div>
          <div className="interview-modal__text">
            <h2 className="interview-modal__title">Interview request sent</h2>
            <p className="interview-modal__desc">
              We&apos;ll be in touch to set up the call. Feel free to request interviews with other profiles that
              interest you so you can talk to them in the same day.
            </p>
          </div>
          <div className="interview-modal__actions">
            {showStayHere && (
              <button type="button" className="interview-modal__btn interview-modal__btn--secondary" onClick={onClose}>
                Stay here
              </button>
            )}
            <button
              type="button"
              className="interview-modal__btn interview-modal__btn--primary"
              onClick={onViewOtherProfiles}
            >
              View other profiles
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default InterviewSuccessModal;
